var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    directives: [{
      name: "report",
      rawName: "v-report",
      value: _vm.reportData.wording,
      expression: "reportData.wording"
    }]
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_vm.wording && _vm.wordingPic ? _c('section', {
    staticClass: "mod_tipwording",
    on: {
      "click": _vm.clickWording
    }
  }, [_c('div', {
    staticClass: "text_area"
  }, [_c('div', {
    staticClass: "text_area-hd img"
  }, [_c('img', {
    attrs: {
      "src": _vm.wordingPic
    }
  })]), _c('div', {
    staticClass: "text_area-bd"
  }, [_c('p', [_vm._v(_vm._s(_vm.wordingTitle))])]), _c('div', {
    staticClass: "text_area-ft"
  }, [_vm.url ? _c('SvgIcons', {
    attrs: {
      "type": "arrow_right"
    }
  }) : _vm._e()], 1)])]) : _c('div', {
    staticClass: "gift_a"
  }, [_c('img', {
    staticClass: "left_img",
    attrs: {
      "src": "//puui.qpic.cn/vupload/0/20181023_1540285077148_q3cnp2cgw88.jpeg/0",
      "alt": ""
    }
  }), _vm.wording ? _c('div', {
    staticClass: "txt"
  }, [_vm._v(_vm._s(_vm.wordingTitle))]) : _vm.payVip && _vm.payVip.endTime ? _c('div', {
    staticClass: "txt"
  }, [_vm._v("尊贵的VIP，下面是为您准备的专属福利。")]) : _c('div', {
    staticClass: "txt"
  }, [_vm._v("新朋友您好，下面是为您准备的新人优惠。")])])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };